import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import bg1 from "../../Assests/bg1.png";
import impact1 from "../../Assests/impact1.png";
import impact2 from "../../Assests/impact2.png";
import impact3 from "../../Assests/impact3.png";
import impact4 from "../../Assests/impact4.png";
import impact5 from "../../Assests/impact5.png";
import impact6 from "../../Assests/impact6.png";

const industries = [
  {
    title: "Travel",
    description:
      "Making journeys smoother with smart booking, secure payments, and seamless travel experiences.",
    icon: <img src={impact1} alt="" width={40} height={40} />,
  },
  {
    title: "EduTech",
    description:
      "Empowering learners and educators with digital tools that simplify access to quality education.",
    icon: <img src={impact2} alt="" width={40} height={40} />,
  },
  {
    title: "Insurance",
    description:
      "Simplifying protection—fast, transparent, and affordable insurance solutions for every need.",
    icon: <img src={impact3} alt="" width={40} height={40} />,
  },
  {
    title: "E-commerce",
    description:
      "Powering online businesses with integrated payment solutions and customer-friendly tools.",
    icon: <img src={impact4} alt="" width={40} height={40} />,
  },
  {
    title: "Wealth",
    description:
      "Making journey smoother with smart booking, secure transparency, individuals and families to grow.",
    icon: <img src={impact5} alt="" width={40} height={40} />,
  },
  {
    title: "Corporate",
    description:
      "Supporting enterprises with scalable payment systems, compliance tools, and digital infrastructure.",
    icon: <img src={impact6} alt="" width={40} height={40} />,
  },
];

const IndustriesSection = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: `linear-gradient(45deg, rgba(129, 52, 175, 0.7), rgba(158, 63, 236, 0.6), rgba(95, 20, 150, 0.7)), url(${bg1}) no-repeat center/cover`,
        backgroundBlendMode: 'multiply',
        color: "#fff",
        textAlign: "center",
        px: { xs: 3, md: 3 },
        py: { xs: 6, md: 8 },
      }}
    >
      <Typography variant="subtitle1" sx={{ opacity: 0.8, mb: 1 }}>
        Industries
      </Typography>

      <Typography
        variant="h4"
        sx={{
          fontWeight: "bold",
          mb: 1,
          fontFamily: '"SF Pro Display", "Poppins", sans-serif',
        }}
      >
        Expanding Our Impact Across Industries
      </Typography>

      <Typography
        variant="body1"
        sx={{
          maxWidth: 700,
          mx: "auto",
          opacity: 0.85,
          mb: 6,
          fontFamily: '"SF Pro Display", sans-serif',
        }}
      >
        We're stepping into new sectors to deliver smarter, more connected
        experiences across travel, insurance, education, and beyond.
      </Typography>

      <Grid
        container
        spacing={3}
        justifyContent="center"
        sx={{ width: "100%", maxWidth: 1200 }}
      >
        {industries.map((item, index) => (
          <Grid item size={{xs: 12, sm: 6 , md: 4}} key={index}>
            <Card
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                borderRadius: 4,
                color: "#fff",
                height: "100%",
                minHeight: 250,
                backdropFilter: "blur(12px)",
                transition: "0.3s",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.25)",
                  transform: "translateY(-4px)",
                },
              }}
            >
              <CardContent sx={{ p: 3, display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                    ml: 0,
                  }}
                >
                  {item.icon}
                </Box>

                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    mb: 1,
                    textAlign: "left",
                    fontFamily: '"SF Pro Display", sans-serif',
                  }}
                >
                  {item.title}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    opacity: 0.85,
                    mb: 2,
                    textAlign: "left",
                    fontFamily: '"SF Pro Display", sans-serif',
                  }}
                >
                  {item.description}
                </Typography>

                <Box sx={{ mt: 'auto', pt: 2, display: 'flex', justifyContent: 'flex-start', width: '100%' }}>
                  <Button
                    component="div"
                    sx={{
                      color: "#fff",
                      textTransform: "none",
                      p: 0,
                      m: 0,
                      minWidth: 'auto',
                      fontFamily: '"SF Pro Display", sans-serif',
                      textAlign: 'left',
                      display: 'inline-block',
                      textDecoration: 'none',
                      "&:hover": { 
                        textDecoration: "underline",
                        backgroundColor: 'transparent',
                      },
                    }}
                  >
                    Read More &gt;
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default IndustriesSection;
